<template>
  <div>
    <ManageUsersHead
        :countFilterParams="countFilterParams"
        :showFilter="showFilter"
        :navTabs="navTabs"
        @changeTab="(data) => $emit('changeTab', data)"
        @toggleFilter="toggleFilter"
        @filter="$emit('filter')"
        @reload="$emit('reload')"
        @selectAll="selectAll"
        @massBlock="$emit('massBlock')"
    />

    <div class="table-filter-wrap">

      <ManageUsersFilter
          v-if="!navTabs.groups.active"
          :showFilter="showFilter"
          :filterGetParams="filterGetParams"
          :navTabs="navTabs"
          @close="closeFilter"
          @changeFilter="data => $emit('changeFilter', data)"
          @resetFilter="$emit('resetFilter')"
      />

      <ManageUsersTable
          v-if="!navTabs.groups.active"
          :navTabs="navTabs"
          :selectedNow="selectedNow"
          @showMore="$emit('showMore')"
          @resetFilter="$emit('resetFilter')"
          @updateTable="$emit('updateTable')"
          @downloadFiles="type => $emit('downloadFiles', type)"
          @reload="$emit('reload')"
      />

      <ManageUsersGroupsTable
          v-else
          :navTabs="navTabs"
          @showMore="$emit('showMore')"
          @resetFilter="$emit('resetFilter')"
          @updateTable="$emit('updateTable')"
          @reload="$emit('reload')"
      />
    </div>
  </div>
</template>

<script>

  import ManageUsersHead from "./ManageUsersHead/ManageUsersHead";
  import ManageUsersFilter from "./ManageUsersFilter/ManageUsersFilter";
  import ManageUsersTable from "./ManageUsersTable/ManageUsersTable";
  import ManageUsersGroupsTable from "./ManageUsersGroupsTable/ManageUsersGroupsTable";

  export default {
    name: "ManageUsersTableUser",

    components: {
      ManageUsersGroupsTable,
      ManageUsersHead,
      ManageUsersFilter,
      ManageUsersTable,
    },

    props: {
      countFilterParams: Number,
      filterGetParams: Object,
      navTabs: Object,
    },

    data(){
      return{
        selectedNow: false,
        showFilter: false,
      }
    },

    methods: {
      closeFilter() {
        this.showFilter = false
      },

      toggleFilter() {
        this.showFilter = !this.showFilter
      },

      selectAll(val) {
        this.selectedNow = val
      },
    }
  }
</script>

<style scoped>

</style>
